import React, { useState } from 'react';
import { Tabs, Card, Row, Col, Typography } from 'antd';
import { 
    ShoppingCartOutlined, UnorderedListOutlined, RollbackOutlined, 
    RadarChartOutlined, BarChartOutlined, DollarCircleOutlined 
} from '@ant-design/icons';
import PostSales from './post_sales_order';
import SalesList from './sales_list';
import CloseSales from './close_reverse_sales';
import OrderTracking from './order_tracking';
import SalesReports from '../Reports/sales_reports';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const SalesOperationsHub = ({ defaultTab = '1' }) => {
    const [activeTab, setActiveTab] = useState(defaultTab);

    return (
        <div style={{ padding: '4px' }}>
            {/* Header Banner */}
            <div className="welcome-banner-card" style={{ marginBottom: '24px' }}>
                <Row justify="space-between" align="middle" gutter={[16, 16]}>
                    <Col xs={24} md={18}>
                        <Title level={2} className="welcome-title" style={{ margin: 0, fontWeight: '800', letterSpacing: '-0.5px' }}>
                            Sales Operations Hub
                        </Title>
                        <Text className="welcome-subtitle" style={{ fontSize: '15px', display: 'block', marginTop: '6px' }}>
                            Create new sales orders, view historical records, manage invoice reversals, monitor deliveries, and track analytics reports.
                        </Text>
                    </Col>
                    <Col xs={24} md={6} className="welcome-time-col">
                        <div className="welcome-time-container">
                            <DollarCircleOutlined style={{ marginRight: '8px' }} />
                            <span>Sales Terminal</span>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Main Tabs Container */}
            <Card className="dashboard-card" bordered={false} bodyStyle={{ padding: '24px' }}>
                <Tabs activeKey={activeTab} onChange={setActiveTab} size="large" centered>
                    <TabPane 
                        tab={
                            <span>
                                <ShoppingCartOutlined style={{ marginRight: 8 }} />
                                Post Sales
                            </span>
                        } 
                        key="1"
                    >
                        <div style={{ marginTop: '16px' }}>
                            <PostSales />
                        </div>
                    </TabPane>
                    
                    <TabPane 
                        tab={
                            <span>
                                <UnorderedListOutlined style={{ marginRight: 8 }} />
                                Sales List
                            </span>
                        } 
                        key="2"
                    >
                        <div style={{ marginTop: '16px' }}>
                            <SalesList />
                        </div>
                    </TabPane>

                    <TabPane 
                        tab={
                            <span>
                                <RollbackOutlined style={{ marginRight: 8 }} />
                                Close/Reverse Sales
                            </span>
                        } 
                        key="3"
                    >
                        <div style={{ marginTop: '16px' }}>
                            <CloseSales />
                        </div>
                    </TabPane>

                    <TabPane 
                        tab={
                            <span>
                                <RadarChartOutlined style={{ marginRight: 8 }} />
                                Order Tracking
                            </span>
                        } 
                        key="4"
                    >
                        <div style={{ marginTop: '16px' }}>
                            <OrderTracking />
                        </div>
                    </TabPane>

                    <TabPane 
                        tab={
                            <span>
                                <BarChartOutlined style={{ marginRight: 8 }} />
                                Sales Reports
                            </span>
                        } 
                        key="5"
                    >
                        <div style={{ marginTop: '16px' }}>
                            <SalesReports />
                        </div>
                    </TabPane>
                </Tabs>
            </Card>
        </div>
    );
};

// Route wrapper components to maintain state integrity without re-mounting
export const SalesPostWrapper = () => <SalesOperationsHub defaultTab="1" />;
export const SalesListWrapper = () => <SalesOperationsHub defaultTab="2" />;
export const SalesCloseWrapper = () => <SalesOperationsHub defaultTab="3" />;
export const SalesTrackingWrapper = () => <SalesOperationsHub defaultTab="4" />;
export const SalesReportsWrapper = () => <SalesOperationsHub defaultTab="5" />;

export default SalesOperationsHub;
